/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementAttachmentViewModel } from "../types/CourseRegistrationManagementAttachmentViewModel.ts";
import { personAttachmentRGViewModelSchema } from "./personAttachmentRGViewModelSchema.ts";

export const courseRegistrationManagementAttachmentViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do anexo.")),
  fileName: z.string().describe("Nome do arquivo enviado.").nullish(),
  url: z
    .string()
    .describe(
      "URL SAS do arquivo para exibição inline no front. Nula quando não há arquivo ou quando o endpoint não a popula. Opcional.",
    )
    .nullish(),
  description: z.string().describe("Descrição do arquivo. Opcional.").nullish(),
  date: z
    .string()
    .datetime()
    .describe("Data de envio do arquivo. Opcional.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se o arquivo está ativo.")),
  default: z.optional(
    z.boolean().describe("Indica se este é o arquivo padrão do grupo."),
  ),
  approvedByPersonName: z
    .string()
    .describe("Nome da pessoa que aprovou este arquivo. Opcional.")
    .nullish(),
  textOcr: z
    .string()
    .describe("Texto extraído via OCR do arquivo. Opcional.")
    .nullish(),
  personAttachmentsRG: z.optional(
    z.lazy(() => personAttachmentRGViewModelSchema),
  ),
}) as unknown as ToZod<CourseRegistrationManagementAttachmentViewModel>;
